import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { SubscriptionData } from 'src/app/model/stripe-models/subscription/subscription-data';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { StripeService } from 'src/app/services/stripe-service/stripe.service';

@Component({
    selector: 'app-abonnements',
    templateUrl: './abonnements.component.html',
    styleUrls: ['./abonnements.component.css'],
    standalone: false
})
export class AbonnementsComponent implements OnInit {
  @Input() admin: boolean;
  @Input() orgId: number
  @Input() packageId: string;
  @Input() packageNumber: string;
  @Input() startDate: Date;
  @Input() endDate: Date;
  @Input() licensesUsed: number;
  @Input() licensesTotal: number;
  @Input() price: number;
  @Input() features: string[];
  @Input() subscription: SubscriptionData;
  @Output() subscriptionChange = new EventEmitter<SubscriptionData>();
  @Output() isSubscriptionSelected = new EventEmitter<boolean>();
  isExpanded: boolean = false;
  public isPriorityLicense: boolean = false;


  constructor(private stripeService: StripeService,
    private dialogService: DialogService) { }

  get usedPercentage(): number {
    return (this.licensesUsed / this.licensesTotal) * 100;
  }

  get remainingPercentage(): number {
    return 100 - this.usedPercentage;
  }

  // get dateRangeFormatted(): string {
  //   return `${this.startDate} - ${this.endDate}`;
  // }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }

  // private formatDate(date: Date): string {
  //   return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  // }

  onUserAction() {
    this.subscriptionChange.emit(this.subscription);
    this.isSubscriptionSelected.emit(true);
  }

  ngOnInit(): void {
    this.isPriorityLicense = this.checkPriorityLicense();
  }

  async manageSubscription(subscriptionId: string) {
    this.dialogService
      .openConfirmDialog(
        this.subscription.canceled ? 'Wollen Sie die Kündigung wirklich zurückziehen?' : 'Wollen Sie die Abonnement wirklich kündigen?',
        'Abbrechen',
        this.subscription.canceled ? 'Abo fortsetzten' : 'Kündigen'
      )
      .subscribe((confirmed) => {
        if (confirmed) {
          let message = 'Abonnement erfolgreich ' + (this.subscription.canceled ? 'fortgesetzt' : 'gekündigt');
          if (this.subscription.canceled) {
            this.stripeService.resumeSubscription(this.orgId + "", subscriptionId).subscribe(data => {
              if (typeof data == "string") {
                this.subscription.canceled = false;
                this.subscriptionChange.emit(this.subscription);
              }
              else if (data.status == 401) message = 'Sie sind nicht eingeloggt.';
              else message = data.message;

              this.dialogService.openDialog("Abonnement-Fortsetzung", message);
            });
          }
          else {
            this.stripeService.cancelSubscription(this.orgId + "", subscriptionId).subscribe(data => {
              if (typeof data == "string") {
                this.subscription.canceled = true;
                this.subscriptionChange.emit(this.subscription);
              }
              else if (data.status == 401) message = 'Sie sind nicht eingeloggt.';
              else message = data.message;

              this.dialogService.openDialog("Abonnement-Kündigung", message);
            });
          }
        }
      });
  }

  checkPriorityLicense(): boolean {
    return this.subscription?.name?.toLowerCase().includes('prioritätslizenz') ?? false;
  }

}
